<template>
  <NxRadioButton
  label="Tipo de Pessoa"
  :listOptions="tipoPessoaOptions"
  name="tipoPessoa"
  @update:value="handleValueUpdate"
  />
</template>

<script>
import NxRadioButton from '@/components/nexum/components/buttons/NxRadioButton.vue'
import { useReactiveModelMixin } from '../../mixins'
export default {
  components: { NxRadioButton },
  name: 'NxPersonType',
  mixins: [useReactiveModelMixin('value')],
  props: {
    value: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      tipoPessoaOptions: [
        { value: null, text: 'Todas' },
        { value: 'PF', text: 'Pessoa Física' },
        { value: 'PJ', text: 'Pessoa Jurídica' }
      ]
    }
  },
  methods: {
    handleValueUpdate (newValue) {
      this.$emit('update:value', {value: newValue})
    }
  }
}
</script>

<style scoped>
.tipo-pessoa-selector {
  width: 75%;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxPersonType.vue